// Unlike dropdown_controller, no outside-click close — for inline panels
// (filters, expandable sections) that shouldn't collapse mid-interaction.

import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["panel"]

  toggle(event) {
    if (event) event.preventDefault()
    this.panelTarget.classList.toggle("hidden")
  }
}
